import React from 'react';
import './SkeletonLoaderAboutUs.css'; // Custom CSS file for styling the skeleton

const SkeletonLoaderAboutUs = () => {
  return (
    <section className="about-wrap-skeleton" id="aboutus">
      <div className="container">
        <div className="heading">
          <div className="content-title-skeleton mb-15">
            <span className="ruby">
              <div className="skeleton-img" />
              <div className="skeleton-title" />
              <div className="skeleton-img" />
            </span>
          </div>
        </div>
        <div className="row gx-5 align-items-center">
          {/* Left Section - Image */}
          <div className="col-lg-6">
            <div className="about-sec-bg-skeleton">
              <div className="skeleton-image" />
            </div>
          </div>
          {/* Right Section - Content */}
          <div className="col-lg-6">
            <div className="about-content-skeleton">
              <div className="skeleton-subtitle mb-15" />
              <div className="skeleton-paragraph" />
              <div className="skeleton-paragraph" />
              <div className="skeleton-paragraph short" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SkeletonLoaderAboutUs;
